import { render, staticRenderFns } from "./FreeTalk.vue?vue&type=template&id=4f900ba2&scoped=true&"
import script from "./FreeTalk.vue?vue&type=script&lang=js&"
export * from "./FreeTalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f900ba2",
  null
  
)

export default component.exports